import * as firebase from 'firebase';

const config = { apiKey: 'AIzaSyDPc9rpIFnD1FVZPgdfc3ldBEsIZOPnnLc', authDomain: 'beckfriends-2-a4131.firebaseapp.com', databaseURL: 'https://beckfriends-2-a4131.firebaseio.com', projectId: 'beckfriends-2-a4131', storageBucket: 'beckfriends-2-a4131.appspot.com', messagingSenderId: '665657673006' };

const firebaseinit = firebase.initializeApp(config);
export default firebaseinit;
